module.exports = __webpack_public_path__ + "img/back2.f35e7ad3.png";